// 테스트 관련 코드, 추후 삭제 예정
/**
 * 가이드확인 — 테스트 임시 페이지
 *
 * 상단 콤보(활성 에이전트 목록)에서 에이전트를 고르면,
 * 해당 에이전트의 가이드(TM_AGENT.AGENT_GUIDE)를 하단에 HTML로 렌더한다.
 */
import { useEffect, useState } from 'react';
import { Select } from '@indipia/ui-core';
import { fetchAgents, fetchAgentGuide, type AgentItem } from './testApi';

export function TestGuidePage() {
  const [agents, setAgents] = useState<AgentItem[]>([]);
  const [selected, setSelected] = useState('');
  const [guide, setGuide] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // 에이전트 목록 로드
  useEffect(() => {
    fetchAgents()
      .then(setAgents)
      .catch(() => setError('에이전트 목록을 불러오지 못했습니다.'));
  }, []);

  // 에이전트 선택 시 가이드 조회
  useEffect(() => {
    if (!selected) { setGuide(null); setError(null); return; }
    setLoading(true);
    setError(null);
    setGuide(null);
    fetchAgentGuide(Number(selected))
      .then((g) => setGuide(g?.agentGuide ?? null))
      .catch(() => setError('가이드를 불러오지 못했습니다.'))
      .finally(() => setLoading(false));
  }, [selected]);

  return (
    <div className="mx-auto max-w-3xl space-y-4 p-6">
      {/* 배너 */}
      <div className="rounded-xl border border-warning bg-surface-subtle px-4 py-3">
        <p className="text-xs font-semibold text-warning">테스트 임시 페이지 — 프로덕션 미노출</p>
        <p className="mt-0.5 text-xs text-text-secondary">가이드확인 · 에이전트 선택 시 가이드 표시</p>
      </div>

      {/* 에이전트 콤보 */}
      <div className="flex items-center gap-3">
        <label className="text-sm text-text-secondary">에이전트</label>
        <Select
          className="min-w-56"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
        >
          <option value="">에이전트를 선택하세요</option>
          {agents.map((a) => (
            <option key={a.agentId} value={a.agentId}>{a.agentName}</option>
          ))}
        </Select>
      </div>

      {/* 본문 */}
      <div className="min-h-[300px] rounded-xl border border-border-default bg-white p-6">
        {loading && <p className="text-sm text-text-secondary">불러오는 중…</p>}
        {!loading && error && <p className="text-sm text-error">{error}</p>}
        {!loading && !error && !selected && (
          <p className="text-sm text-text-secondary">상단에서 에이전트를 선택하세요.</p>
        )}
        {!loading && !error && selected && !guide && (
          <p className="text-sm text-text-secondary">등록된 가이드가 없습니다.</p>
        )}
        {!loading && !error && guide && (
          <div
            className="text-sm leading-relaxed text-text-primary [&_h1]:mb-2 [&_h1]:text-base [&_h1]:font-semibold [&_h2]:mb-2 [&_h2]:mt-4 [&_h2]:font-semibold [&_li]:ml-4 [&_li]:list-disc [&_p]:mb-2 [&_ul]:mb-2"
            dangerouslySetInnerHTML={{ __html: guide }}
          />
        )}
      </div>
    </div>
  );
}
